// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__1F9fS","up":"Chevron_up__1h9XE","down":"Chevron_down__10xol","left":"Chevron_left__1ylqv"};